import { jsx, jsxs } from "react/jsx-runtime";
import {
  Button,
  Col,
  Image,
  Input,
  Layout,
  Row,
  Typography,
  theme,
  Form,
  Flex,
  Grid
} from "antd";
import { withScrollToTop } from "./../../hoc";
import contactImage from "./../../assets/img/contact-image.png";
import EmailApi from "./../../api/EmailApi.js";
import { useState } from "react";
import { EVENT_ACTIONS, track } from "./../../lib/gtag.js";
import { useTranslation } from "@inscore/shared";
const { Title } = Typography;
const { Content } = Layout;
const { useBreakpoint } = Grid;
const ContactUs = () => {
  const { token } = theme.useToken();
  const screens = useBreakpoint();
  const [postingForm, setPostingForm] = useState(false);
  const [form] = Form.useForm();
  const sendEmailApi = EmailApi.sendEmail();
  const { t } = useTranslation();
  const handleFormFinish = async (values) => {
    var _a, _b;
    setPostingForm(true);
    try {
      await sendEmailApi.call(values);
      (_a = window.messageApi) == null ? void 0 : _a.open({
        type: "success",
        content: t("message_sent_success")
      });
      track(EVENT_ACTIONS.SEND_MESSAGE);
      form.resetFields();
    } catch (err) {
      console.error(err);
      (_b = window.messageApi) == null ? void 0 : _b.open({
        type: "error",
        content: t("message_send_error")
      });
    } finally {
      setPostingForm(false);
    }
  };
  return /* @__PURE__ */ jsx(
    Layout,
    {
      style: {
        marginBottom: screens.md ? 40 : 24,
        gap: 8,
        borderRadius: token.borderRadius
      },
      className: "container contact-us",
      children: /* @__PURE__ */ jsx(Content, { children: /* @__PURE__ */ jsxs(Row, { gutter: [0, 32], children: [
        /* @__PURE__ */ jsx(
          Col,
          {
            xs: 24,
            lg: 12,
            style: {
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ jsxs(
              Flex,
              {
                vertical: true,
                gap: screens.md ? 40 : 24,
                style: {
                  width: "512px"
                },
                children: [
                  /* @__PURE__ */ jsx(
                    Title,
                    {
                      level: 1,
                      style: {
                        fontSize: screens.md ? 48 : 32,
                        margin: 0,
                        alignSelf: "flex-start"
                      },
                      children: t("get_in_touch")
                    }
                  ),
                  /* @__PURE__ */ jsxs(
                    Form,
                    {
                      form,
                      name: "register",
                      onFinish: handleFormFinish,
                      layout: "vertical",
                      style: { width: "100%" },
                      scrollToFirstError: true,
                      children: [
                        /* @__PURE__ */ jsx(
                          Form.Item,
                          {
                            name: "email",
                            label: t("email"),
                            rules: [
                              {
                                type: "email",
                                message: t("invalid_email")
                              },
                              {
                                required: true,
                                message: t("required_email")
                              }
                            ],
                            children: /* @__PURE__ */ jsx(
                              Input,
                              {
                                placeholder: t("email_placeholder"),
                                autoComplete: "off"
                              }
                            )
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          Form.Item,
                          {
                            name: "name",
                            label: t("subject_optional"),
                            children: /* @__PURE__ */ jsx(
                              Input,
                              {
                                placeholder: t("subject_placeholder"),
                                autoComplete: "off"
                              }
                            )
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          Form.Item,
                          {
                            name: "message",
                            label: t("your_message"),
                            rules: [
                              {
                                required: true,
                                message: t("required_message")
                              }
                            ],
                            children: /* @__PURE__ */ jsx(
                              Input.TextArea,
                              {
                                placeholder: t("message_placeholder"),
                                rows: 6
                              }
                            )
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          Button,
                          {
                            type: "primary",
                            htmlType: "submit",
                            block: true,
                            loading: postingForm,
                            style: {
                              backgroundColor: token.colorLinkActive,
                              height: 48,
                              marginTop: 8,
                              fontWeight: 500,
                              fontSize: token.fontSizeLG
                            },
                            children: t("send_message")
                          }
                        )
                      ]
                    }
                  )
                ]
              }
            )
          },
          1
        ),
        /* @__PURE__ */ jsx(Col, { xs: 24, lg: 12, children: /* @__PURE__ */ jsx(
          Image,
          {
            src: contactImage,
            alt: "contact-us",
            width: "100%",
            height: "auto",
            style: { objectFit: "contain" },
            preview: false
          }
        ) }, 2)
      ] }) })
    }
  );
};
var stdin_default = withScrollToTop(ContactUs);
export {
  stdin_default as default
};
